// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/FSEX302.woff2", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "Fixedsys Excelsior";
  font-style: normal;
  font-weight: 400;
  font-display: swap;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("woff2");
}
html {
  font-family: Fixedsys Excelsior, monospace;
}

* {
  box-sizing: border-box;
}

#root {
  position: relative;
  width: 100vw;
  height: 100vh;
  display: block;
  top: 0;
  left: 0;
}

#root > canvas {
  width: 100%;
}

.hydra-midi-gui {
  z-index: 1000;
}

.debugger {
  position: fixed;
  top: 0;
  right: 0;
  z-index: 1000;
  background-color: rgba(255, 255, 255, 0.2666666667);
  padding: 1rem;
}

.examples {
  position: fixed;
  bottom: 1rem;
  right: 1rem;
  z-index: 1000;
  display: flex;
  gap: 0.5rem;
  color: #fff;
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.6666666667);
  cursor: pointer;
}

.editor--alt {
  opacity: 0.1;
}

.editor--alt .ace_editor *,
.editor--alt .ace_editor {
  pointer-events: none;
  user-select: none;
  overflow: hidden;
}

.editor {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  padding: 1.25rem 1rem;
  z-index: 1;
}
.editor__error {
  font-family: "Fixedsys Excelsior";
  position: absolute;
  bottom: 0.5rem;
  left: 0.5rem;
  color: #fff;
  overflow: auto;
}
.editor__error__line {
  background-color: rgba(255, 0, 0, 0.4666666667);
  white-space: pre-line;
  max-height: 20vh;
  max-width: calc(100% - 1rem);
  padding: 0.5rem 0.75rem;
  overflow: auto;
}
.editor__error__close {
  position: absolute;
  right: 2px;
  top: 2px;
  cursor: pointer;
}

.editor__code--hidden {
  opacity: 0;
}

.ace_editor {
  font-feature-settings: "liga";
  -webkit-font-smoothing: antialiased;
  line-height: 1.2;
}

.ace_scrollbar {
  opacity: 0;
}

.ace-tm .ace_indent-guide {
  background: none;
}

.ace_line {
  display: inline-block;
  background-color: rgba(0, 0, 0, 0.6);
}
.ace_line > * {
  mix-blend-mode: difference;
}
.ace_line .ace_entity.ace_name.ace_function {
  color: #99cc99;
}
.ace_line .ace_identifier,
.ace_line .ace_support.ace_function {
  color: #fff;
}
.ace_line .ace_comment {
  color: #222;
}
.ace_line .ace_paren {
  color: #ccc;
}
.ace_line .ace_storage,
.ace_line .ace_keyword {
  color: #999;
}
.ace_line .ace_storage + .ace_identifier {
  color: #f99157;
}
.ace_line .ace_constant,
.ace_line .ace_constant.ace_numeric {
  color: #99cc99;
}
.ace_line .ace_string {
  color: #ffcc66;
}
.ace_line .ace_comment,
.ace_line .ace_comment.ace_doc {
  color: #99cc99;
}

.ace_editor.ace_autocomplete {
  border-color: rgba(255, 255, 255, 0.1);
  background-color: rgba(255, 255, 255, 0.2);
}

.ace-tm .ace_marker-layer .ace_selection {
  background: rgba(255, 255, 255, 0.1);
}

.ace-tm .ace_marker-layer .ace_selected-word {
  background-color: rgba(0, 0, 0, 0.5);
}

.ace_marker-layer .ace_bracket {
  background-color: rgba(255, 255, 255, 0.5);
  border: none !important;
}

.ace-marker {
  position: absolute;
  background: rgba(255, 119, 0, 0.2);
}

.ace_cursor {
  background: rgba(255, 119, 0, 0.6666666667);
}`, "",{"version":3,"sources":["webpack://./src/editor/Editor.scss"],"names":[],"mappings":"AAAA;EACC,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,4DAAA;AACD;AAEA;EACC,0CAAA;AAAD;;AAGA;EACC,sBAAA;AAAD;;AAGA;EACC,kBAAA;EACA,YAAA;EACA,aAAA;EACA,cAAA;EACA,MAAA;EACA,OAAA;AAAD;;AAGA;EACC,WAAA;AAAD;;AAGA;EACC,aAAA;AAAD;;AAGA;EACC,eAAA;EACA,MAAA;EACA,QAAA;EACA,aAAA;EACA,mDAAA;EACA,aAAA;AAAD;;AAGA;EACC,eAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;EACA,aAAA;EACA,WAAA;EACA,WAAA;EACA,kDAAA;EACA,eAAA;AAAD;;AAGA;EACC,YAAA;AAAD;;AAEA;;EAEC,oBAAA;EACA,iBAAA;EACA,gBAAA;AACD;;AAEA;EACC,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,qBAAA;EACA,UAAA;AACD;AACC;EACC,iCAAA;EACA,kBAAA;EACA,cAAA;EACA,YAAA;EACA,WAAA;EACA,cAAA;AACF;AACE;EACC,+CAAA;EACA,qBAAA;EACA,gBAAA;EACA,4BAAA;EACA,uBAAA;EACA,cAAA;AACH;AACE;EACC,kBAAA;EACA,UAAA;EACA,QAAA;EACA,eAAA;AACH;;AAKC;EACC,UAAA;AAFF;;AAaA;EACC,6BAAA;EACA,mCAAA;EAEA,gBAAA;AAXD;;AAcA;EACC,UAAA;AAXD;;AAiBA;EACC,gBAAA;AAdD;;AAiBA;EACC,qBAAA;EACA,oCAAA;AAdD;AAgBC;EACC,0BAAA;AAdF;AAgBC;EACC,cAAA;AAdF;AAgBC;;EAGC,WAAA;AAfF;AAiBC;EAEC,WAAA;AAhBF;AAkBC;EACC,WAAA;AAhBF;AAkBC;;EAGC,WAAA;AAjBF;AAmBC;EACC,cAAA;AAjBF;AAmBC;;EAGC,cAAA;AAlBF;AAoBC;EACC,cAAA;AAlBF;AAqBC;;EAEC,cAAA;AAnBF;;AAuBA;EACC,sCAAA;EACA,0CAAA;AApBD;;AAsBA;EAEC,oCAAA;AApBD;;AAsBA;EACC,oCAAA;AAnBD;;AAqBA;EACC,0CAAA;EACA,uBAAA;AAlBD;;AAqBA;EACC,kBAAA;EACA,kCAAA;AAlBD;;AAqBA;EACC,2CAAA;AAlBD","sourcesContent":["@font-face {\n\tfont-family: \"Fixedsys Excelsior\";\n\tfont-style: normal;\n\tfont-weight: 400;\n\tfont-display: swap;\n\tsrc: url(../assets/FSEX302.woff2) format(\"woff2\");\n}\n\nhtml {\n\tfont-family: Fixedsys Excelsior, monospace;\n}\n\n* {\n\tbox-sizing: border-box;\n}\n\n#root {\n\tposition: relative;\n\twidth: 100vw;\n\theight: 100vh;\n\tdisplay: block;\n\ttop: 0;\n\tleft: 0;\n}\n\n#root > canvas {\n\twidth: 100%;\n}\n\n.hydra-midi-gui {\n\tz-index: 1000;\n}\n\n.debugger {\n\tposition: fixed;\n\ttop: 0;\n\tright: 0;\n\tz-index: 1000;\n\tbackground-color: #fff4;\n\tpadding: 1rem;\n}\n\n.examples {\n\tposition: fixed;\n\tbottom: 1rem;\n\tright: 1rem;\n\tz-index: 1000;\n\tdisplay: flex;\n\tgap: 0.5rem;\n\tcolor: #fff;\n\ttext-shadow: 0 1px 3px #000a;\n\tcursor: pointer;\n}\n\n.editor--alt {\n\topacity: 0.1;\n}\n.editor--alt .ace_editor *,\n.editor--alt .ace_editor {\n\tpointer-events: none;\n\tuser-select: none;\n\toverflow: hidden;\n}\n\n.editor {\n\tposition: absolute;\n\ttop: 0;\n\tleft: 0;\n\twidth: 100%;\n\theight: 100%;\n\tpadding: 1.25rem 1rem;\n\tz-index: 1;\n\n\t&__error {\n\t\tfont-family: \"Fixedsys Excelsior\";\n\t\tposition: absolute;\n\t\tbottom: 0.5rem;\n\t\tleft: 0.5rem;\n\t\tcolor: #fff;\n\t\toverflow: auto;\n\n\t\t&__line {\n\t\t\tbackground-color: #f007;\n\t\t\twhite-space: pre-line;\n\t\t\tmax-height: 20vh;\n\t\t\tmax-width: calc(100% - 1rem);\n\t\t\tpadding: 0.5rem 0.75rem;\n\t\t\toverflow: auto;\n\t\t}\n\t\t&__close {\n\t\t\tposition: absolute;\n\t\t\tright: 2px;\n\t\t\ttop: 2px;\n\t\t\tcursor: pointer;\n\t\t}\n\t}\n}\n\n.editor__code {\n\t&--hidden {\n\t\topacity: 0;\n\t\t//pointer-events: none;\n\t}\n}\n\n.ace_content {\n\t// padding: 1.25rem 1rem;\n}\n.ace_text-layer {\n}\n\n.ace_editor {\n\tfont-feature-settings: \"liga\";\n\t-webkit-font-smoothing: antialiased;\n\n\tline-height: 1.2;\n}\n\n.ace_scrollbar {\n\topacity: 0;\n}\n\n.ace_line_group {\n}\n\n.ace-tm .ace_indent-guide {\n\tbackground: none;\n}\n\n.ace_line {\n\tdisplay: inline-block;\n\tbackground-color: rgba(#000, 0.6);\n\n\t> * {\n\t\tmix-blend-mode: difference;\n\t}\n\t.ace_entity.ace_name.ace_function {\n\t\tcolor: #99cc99;\n\t}\n\t.ace_identifier,\n\t.ace_support.ace_function {\n\t\t//color: #99cc99;\n\t\tcolor: #fff;\n\t}\n\t.ace_comment {\n\t\t//color: #4c886b;\n\t\tcolor: #222;\n\t}\n\t.ace_paren {\n\t\tcolor: #ccc;\n\t}\n\t.ace_storage,\n\t.ace_keyword {\n\t\t//color: #f2777a;\n\t\tcolor: #999;\n\t}\n\t.ace_storage + .ace_identifier {\n\t\tcolor: #f99157;\n\t}\n\t.ace_constant,\n\t.ace_constant.ace_numeric {\n\t\t//color: #a16a94;\n\t\tcolor: #99cc99;\n\t}\n\t.ace_string {\n\t\tcolor: #ffcc66;\n\t\t//color: #c39032;\n\t}\n\t.ace_comment,\n\t.ace_comment.ace_doc {\n\t\tcolor: #99cc99;\n\t}\n}\n\n.ace_editor.ace_autocomplete {\n\tborder-color: rgba(#fff, 0.1);\n\tbackground-color: rgba(#fff, 0.2);\n}\n.ace-tm .ace_marker-layer .ace_selection {\n\t//background: rgba(#fff, 0.4);\n\tbackground: rgba(#fff, 0.1);\n}\n.ace-tm .ace_marker-layer .ace_selected-word {\n\tbackground-color: rgba(#000, 0.5);\n}\n.ace_marker-layer .ace_bracket {\n\tbackground-color: rgba(#fff, 0.5);\n\tborder: none !important;\n}\n\n.ace-marker {\n\tposition: absolute;\n\tbackground: #f703;\n}\n\n.ace_cursor {\n\tbackground: #f70a;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
